import ModalPaymentFailed from './ModalPaymentFailed'

export default ModalPaymentFailed
// eslint-disable-next-line import/export
export * from './ModalPaymentFailed'
